import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class GetCaptchaStatusFormService extends Service {
  constructor({repository}) {
    super()
    this._repository = repository
  }

  /**
   * @return {Promise<CaptchaFormValueObject, Error>} returns the site's captcha siteKey or Error if captcha status is not active
   */
  @inlineError
  async execute({pageName, context}) {
    const [captchaStatusFormError, captchaStatusFormResponse] = await this._repository.getCaptchaStatus({
      pageName,
      context
    })

    if (captchaStatusFormError) {
      return Promise.reject(captchaStatusFormError)
    }

    return captchaStatusFormResponse
  }
}
